<app-dialog-container
  [title]="formattedTitle"
  [showConfirmButton]="false"
  [showCancelButton]="false"
>
  <div class="dashboard-list">
    @if (data.items.length === 0) {
      <p class="no-data">{{ 'noDataMatchingTheFilter' | translate }}</p>
    } @else {
      <div class="list-item header">
        <span class="col-name">{{ 'name' | translate }}</span>
        <span class="col-type">{{ 'type' | translate }}</span>
        <span class="col-department">{{ 'department' | translate }}</span>
        <span class="col-date">{{ 'date' | translate }}</span>
      </div>
      @for (row of sortedItems; track row.id) {
        <div class="list-item" (click)="navigateToItem(row)">
          <span class="col-name">{{ row.name }}</span>
          <span class="col-type">{{ row.type?.name || '-' }}</span>
          <span class="col-department">{{ row.department?.name || '-' }}</span>
          <span class="col-date">
            @if (getRowDate(row.id)) {
              {{ getRowDate(row.id) | date }}
            } @else {
              -
            }
          </span>
        </div>
      }
    }
  </div>
</app-dialog-container>
